(function () {
  var STOP_WORDS = (
    "a an the and or but if then so of to in on for with at by from up out as is are was were be been being it its this that these those your you we our they their them he she his her i me my mine you'd you'll you're it's we're won't don't store page ad about into over more most just very can will get got"
  ).split(/\s+/);
  var stopMap = {};

  STOP_WORDS.forEach(function (word) {
    stopMap[word] = true;
  });

  function queryAll(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function tokens(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, " ")
      .split(/\s+/)
      .filter(function (word) {
        return word.length > 2 && !stopMap[word];
      })
      .filter(function (word, index, list) {
        return list.indexOf(word) === index;
      });
  }

  function lead(text, count) {
    return String(text || "")
      .trim()
      .split(/\s+/)
      .slice(0, count || 7)
      .join(" ");
  }

  function band(score) {
    if (score >= 75) return "strong";
    if (score >= 45) return "leaky";
    return "broken";
  }

  function bandLabel(tone) {
    return {
      strong: "Strong handoff",
      leaky: "Leaky handoff",
      broken: "Broken handoff"
    }[tone];
  }

  function escapeHtml(text) {
    return String(text || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function jobWord(job) {
    return {
      educate: "educate",
      capture: "reassure and capture",
      sell: "sell now"
    }[job];
  }

  function init(root) {
    if (root.dataset.bdTemperatureMatchReady === "true") {
      return;
    }

    root.dataset.bdTemperatureMatchReady = "true";

    var inputAd = root.querySelector('[data-bd-input="ad"]');
    var inputOffer = root.querySelector('[data-bd-input="offer"]');
    var inputTemp = root.querySelector('[data-bd-input="temp"]');
    var inputPage = root.querySelector('[data-bd-input="page"]');
    var inputJob = root.querySelector('[data-bd-input="job"]');

    var tabAuto = root.querySelector('[data-bd-tab="auto"]');
    var tabManual = root.querySelector('[data-bd-tab="manual"]');
    var paneAuto = root.querySelector('[data-bd-pane="auto"]');
    var paneManual = root.querySelector('[data-bd-pane="manual"]');

    var runAuto = root.querySelector('[data-bd-run-auto]');
    var toManualButtons = queryAll(root, "[data-bd-to-manual]");
    var registerButtons = queryAll(root, "[data-bd-register]");

    var resultCard = root.querySelector("[data-bd-result]");
    var gateCard = root.querySelector("[data-bd-gate]");
    var score = root.querySelector('[data-bd-output="score"]');
    var bandNode = root.querySelector('[data-bd-output="band"]');
    var exampleNode = root.querySelector('[data-bd-output="example"]');
    var biggestBreak = root.querySelector('[data-bd-output="break"]');
    var dims = root.querySelector('[data-bd-output="dims"]');
    var cta = root.querySelector('[data-bd-output="cta"]');

    var FIX = {
      message:
        "Make the page’s headline echo the ad’s exact promise. The first line they read should be the thing they clicked for.",
      offer:
        "Put the exact offer from the ad in the first screen. If the ad says 30% off, the page says 30% off, up top.",
      intent_cold:
        "This is cold traffic on a page built to sell. Lead with the problem and the proof first, earn the click before you ask for the sale.",
      intent_hot:
        "This is hot traffic on a page that explains. They came to act, so give them the offer and a clear path to buy, not a lecture.",
      intent_warm:
        "The page’s job is a step off from where this visitor is. Match it: reassure a warm visitor, don’t make them start over.",
      intent_ok: "Intent lines up. The page’s job matches how ready the visitor was."
    };

    function compute() {
      var adRaw = inputAd.value;
      var pageRaw = inputPage.value;
      var offerRaw = inputOffer.value;
      var temp = inputTemp.value;
      var job = inputJob.value;

      var adTokens = tokens(adRaw);
      var pageTokens = tokens(pageRaw);
      var overlap = adTokens.filter(function (token) {
        return pageTokens.indexOf(token) > -1;
      });
      var message = adTokens.length ? Math.round((100 * overlap.length) / adTokens.length) : 0;

      var hasOffer = offerRaw.trim().length > 0;
      var offer = null;

      if (hasOffer) {
        var rawPage = String(pageRaw || "").toLowerCase();
        var offerTokens = tokens(offerRaw).concat(offerRaw.match(/\d+/g) || []);
        var found = offerTokens.some(function (token) {
          return token && rawPage.indexOf(String(token).toLowerCase()) > -1;
        });
        offer = found ? 100 : 25;
      }

      var tempIndex = { cold: 0, warm: 1, hot: 2 }[temp];
      var jobIndex = { educate: 0, capture: 1, sell: 2 }[job];
      var distance = Math.abs(tempIndex - jobIndex);
      var intent = [100, 55, 15][distance];

      var overall = hasOffer
        ? Math.round(0.45 * message + 0.2 * offer + 0.35 * intent)
        : Math.round(0.6 * message + 0.4 * intent);

      var active = [
        ["message", message],
        ["intent", intent]
      ];

      if (hasOffer) {
        active.push(["offer", offer]);
      }

      active.sort(function (a, b) {
        return a[1] - b[1];
      });

      var worst = active[0][0];
      var breakHtml;

      if (worst === "message") {
        breakHtml =
          "Your ad opens with <b>&ldquo;" +
          escapeHtml(lead(adRaw)) +
          "&rdquo;</b>. The page opens with <b>&ldquo;" +
          escapeHtml(lead(pageRaw)) +
          "&rdquo;</b>. The visitor clicked for one thing and landed on another.";
      } else if (worst === "offer") {
        breakHtml =
          "Your ad promises <b>&ldquo;" +
          escapeHtml(offerRaw) +
          "&rdquo;</b>, but it’s nowhere in the first screen of the page. People assume the deal’s gone and leave.";
      } else {
        breakHtml =
          "This is <b>" +
          temp +
          "</b> traffic, but the page is built to <b>" +
          jobWord(job) +
          "</b>. The page is answering a question this visitor hasn’t asked yet.";
      }

      var intentFix =
        distance === 0
          ? FIX.intent_ok
          : tempIndex > jobIndex
            ? FIX.intent_hot
            : jobIndex > 1
              ? FIX.intent_cold
              : FIX.intent_warm;

      return {
        overall: overall,
        pillar: worst,
        breakHtml: breakHtml,
        dims: [
          { name: "Message", score: message, fix: FIX.message },
          { name: "Offer", score: offer, fix: FIX.offer, na: !hasOffer },
          { name: "Intent", score: intent, fix: intentFix }
        ]
      };
    }

    function render(isExample) {
      var result = compute();
      var tone = band(result.overall);

      score.innerHTML = result.overall + "<small>/100</small>";
      bandNode.className = "o-band " + tone;
      bandNode.textContent = bandLabel(tone);
      biggestBreak.innerHTML = result.breakHtml;
      exampleNode.style.display = isExample ? "" : "none";

      dims.innerHTML = "";

      result.dims.forEach(function (dim) {
        if (dim.na) {
          dims.innerHTML +=
            '<div class="dim na"><div class="dh"><span class="dn">' +
            dim.name +
            '</span><span class="dv">not given</span></div><div class="bar"><i style="width:0%"></i></div><div class="fix">Add the offer your ad names above to score this.</div></div>';
          return;
        }

        var dimTone = band(dim.score);
        dims.innerHTML +=
          '<div class="dim s-' +
          dimTone +
          '"><div class="dh"><span class="dn">' +
          dim.name +
          '</span><span class="dv">' +
          dim.score +
          '/100</span></div><div class="bar"><i style="width:' +
          dim.score +
          '%"></i></div><div class="fix">' +
          dim.fix +
          "</div></div>";
      });

      if (result.pillar === "offer") {
        cta.textContent = "See what the leak is worth → Conversion Rate Calculator";
        cta.setAttribute("href", root.dataset.conversionUrl || "#");
      } else {
        cta.textContent = "Narrow down the cause → take the Bottleneck Quiz";
        cta.setAttribute("href", root.dataset.xrayUrl || "#");
      }
    }

    function selectTab(which) {
      var auto = which === "auto";
      tabAuto.setAttribute("aria-selected", auto ? "true" : "false");
      tabManual.setAttribute("aria-selected", auto ? "false" : "true");
      paneAuto.hidden = !auto;
      paneManual.hidden = auto;
      gateCard.hidden = true;
      resultCard.hidden = false;
      render(auto);
    }

    tabAuto.addEventListener("click", function () {
      selectTab("auto");
    });

    tabManual.addEventListener("click", function () {
      selectTab("manual");
    });

    runAuto.addEventListener("click", function () {
      resultCard.hidden = true;
      gateCard.hidden = false;
    });

    toManualButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        selectTab("manual");
      });
    });

    registerButtons.forEach(function (button) {
      button.addEventListener("click", function () {
        var registerUrl = root.dataset.registerUrl;
        if (registerUrl) {
          window.location.href = registerUrl;
        }
      });
    });

    [inputAd, inputOffer, inputTemp, inputPage, inputJob].forEach(function (field) {
      field.addEventListener("input", function () {
        render(tabAuto.getAttribute("aria-selected") === "true");
      });
      field.addEventListener("change", function () {
        render(tabAuto.getAttribute("aria-selected") === "true");
      });
    });

    render(true);
  }

  function boot() {
    queryAll(document, "[data-bd-temperature-match]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
